"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.attachAudioPresenterSources = attachAudioPresenterSources;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _Sources = require("@studio/constants/Sources");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
// we are creating and audioPresenter for each screenPresenter or cameraPresenter that is unmuted
function attachAudioPresenterSources(sources, attendeeMuteStatus) {
  var unMutedPresenters = sources && sources.filter(function (src) {
    var sourceValue = getSourceValue(src);
    return src && [_Sources.CAMERA_PRESENTER, _Sources.SCREEN_PRESENTER].includes(src.type) && src.value && !attendeeMuteStatus[sourceValue];
  }) || [];
  // This should make sure that duplicate audio presenter is not added to program
  var audioPresenterSources = [];
  unMutedPresenters.forEach(function (source) {
    var sourceValue = getSourceValue(source);
    var audioSourceIndex = sources.findIndex(function (src) {
      return src.value === source._id && src.type === _Sources.AUDIO_PRESENTER;
    });
    if (audioSourceIndex <= -1) {
      audioPresenterSources.push(_objectSpread(_objectSpread({}, source), {}, {
        _id: sourceValue,
        type: _Sources.AUDIO_PRESENTER,
        value: source._id
      }));
    }
  });
  return sources ? sources.concat(audioPresenterSources) : [];
}

/**
 * @description Returns a source value. if the value is unassigned,
 * it returns a concatenated value with the source id
 * @param {Object} source
 * @returns String
 */
function getSourceValue(source) {
  var sourceValue = source.value;
  if (sourceValue === _Sources.UNASSIGNED) {
    sourceValue = "".concat(_Sources.UNASSIGNED, "-").concat(source._id);
  }
  return sourceValue;
}